<template>
  <page-edicion>
    <page-header title="Crear plan" back-to="/planes" />
    <formulario :plan="plan" @submit="insertar" />
  </page-edicion>
</template>

<script>
import Formulario from "./Formulario.vue";
import planesApi from "@/services/planes.js";

export default {
  components: { Formulario },
  data() {
    return {
      plan: planesApi.crear(),
    };
  },
  methods: {
    insertar() {
      planesApi.insertar(this.plan).then(() => {
        this.$messages.success("Se ha creado el plan");
        this.$router.push({ path: "/planes" });
      });
    },
  },
};
</script>
